import { motion } from 'motion/react';
import { Stack, Typography } from '@mui/material';
import { MotionContainer, varFade } from './animate';
import useLocales from '../hooks/useLocales';
import Image from './Image';

const FeatureUnavailable = () => {
    const { translate } = useLocales();

    return (
        <Stack
            component={MotionContainer}
            sx={{
                textAlign: 'center',
                mt: 10,
                justifyContent: 'center',
                alignItems: 'center',
                gap: 5,
            }}
        >
            <motion.div variants={varFade().in}>
                <Typography variant="h3" paragraph>
                    {translate('components.featureUnavailable.title')}
                </Typography>
                <Typography sx={{ color: 'text.secondary' }}>
                    {translate('components.featureUnavailable.description')}
                </Typography>
            </motion.div>

            <motion.div variants={varFade().in} aria-hidden>
                <Image
                    disabledEffect
                    visibleByDefault
                    alt=""
                    src={'/assets/illustrations/wondering.svg'}
                    sx={{ width: 400 }}
                />
            </motion.div>
        </Stack>
    );
};

export default FeatureUnavailable;
